import { Modal } from "react-bootstrap";
import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import TenantContext from "../../context/tenant/TenantContext";

const NewDocumentDiv = (props) => {
  const {
    column_width = 4,
    dataVal = null,
    handleUploadFile = () => {},
    hideUpload = false,
    title = "",
    isBlurDocuments = false,
    llCreated = false,
  } = props;

  const { _t } = useTranslator();
  const [missingDocPopup, setMissingDocPopup] = useState(false);
  const [reasonMessage, setReasonMessage] = useState("");
  const [reasonSubmitLoading, setReasonSubmitLoading] = useState(false);
  const tenantContext = useContext(TenantContext);
  const { submitReasonHandler } = tenantContext;

  const handleReason = async () => {
    try {
      setReasonSubmitLoading(true);
      const payload = {
        reason: reasonMessage,
        document_type: dataVal,
      };
      await submitReasonHandler(payload);
    } catch (err) {
      console.log(err, "error submitting reason");
    } finally {
      setReasonMessage("");
      setMissingDocPopup(false);
      setReasonSubmitLoading(false);
    }
  };

  const fetchDocToolTip = () => {
    switch (dataVal) {
      case constants.firstMonthPayslip:
      case constants.secondMonthPayslip:
      case constants.thirdMonthPayslip:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadYourLatestPayslip")}
            </span>
            <ol>
              <li>{_t("accessYourCompanysPortalSearchForPayslip")}</li>
              <li>{_t("ifNotLookForPayslipOrTheCompanyNameInYourEmail")}</li>
              <li>{_t("ifNotWriteToHRRequestingDirectly")}</li>
            </ol>
          </>
        );
        break;
      case constants.employment_contract:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadYourEmployeeContract")}
            </span>
            <ol>
              <li>{_t("logIntoYourCompanysPortal")}</li>
              <li>{_t("lookForTheDocumentsOrContractsSection")}</li>
            </ol>
          </>
        );
        break;
      case constants.deduction_certificate:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheTaxWithholdingCertificate")}
            </span>
            <ol>
              <li>{_t("fromYourCompanysEmployeePortalOrAskHR")}</li>
              <li>
                {_t("fromSocialSecurity")}
                <ol>
                  <li>
                    {_t("access")}{" "}
                    <a
                      href="https://prestaciones.seg-social.es/servicio/certificado-retenciones-ingresos-irpf.html?categoria=certificados"
                      target="_blank"
                    >
                      {_t("socialSecurity")}
                    </a>
                    {_t("toBeginTheApplication")}
                  </li>
                  <li>{_t("answerTheQuestions")}</li>
                  <li>
                    {_t("identifyYourselfWithCl@veDigitalCertificateDNIeOrSMS")}
                  </li>
                  <li>
                    {_t(
                      "clickOnPersonalIncomeTaxWithholdingCertificateAndDownloadLastYearsOne"
                    )}
                  </li>
                </ol>
              </li>
            </ol>
          </>
        );
        break;
      case constants.previous_working_life_certificate:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheInformeDeVidaLaboral")}
            </span>
            <ol>
              <li>
                {_t("goTo")}{" "}
                <a
                  target="_blank"
                  className="btn-link"
                  href="https://portal.seg-social.gob.es/wps/portal/importass/importass/Categorias/Vida+laboral+e+informes/Informes+sobre+tu+situacion+laboral/Informe+de+tu+vida+laboral"
                >
                  {_t("socialSecurity")}
                </a>{" "}
                {_t("andClickOnCheckWorkLifeCertificate")}
              </li>
              <li>
                {_t("identifyYourselfUsingClaveDigitalCertificateDNIeOrSMS")}
              </li>
              <li>{_t("clickOnWorkLifeCertificateDownloadTheDocument")}</li>
            </ol>
          </>
        );
        break;
      case constants.income_tax_return:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadLastIncomeTaxReturnModelo100")}
            </span>
            <ol>
              <li>
                {_t("accessThe")}{" "}
                <a
                  href="https://sede.agenciatributaria.gob.es/static_files/common/html/selector_acceso/SelectorAccesos.html?ref=%2Fwlpl%2FSCEJ-MANT%2FCONSUL%2Findex.zul%3FMODELO%3D100%26EJERCICIO%3D-1&aut=CPRE"
                  target="_blank"
                >
                  {_t("taxAgency")}
                </a>
                .
              </li>
              <li>
                {" "}
                {_t("identifyYourselfUsingClaveDigitalCertificateOrDNIe")}
              </li>
              <li>
                {_t(
                  "enterYourDNIOrNIEOInTaxIDChooseForm100EnterTheLastFiscalYearIfItIsNotYetJuneChooseTheOneFromThePreviousYearAndPressSearch"
                )}
              </li>
              <li>{_t("onceYouSeeTheFileClickOnView")}</li>
              <li>{_t("downloadTheDocumentWithTheArrowIcon")}</li>
            </ol>
          </>
        );
        break;
      case constants.fractioned_tax_return:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheLastQuarterlyIRPFPaymentModelo130")}
            </span>
            <ol>
              <li>
                {_t("accessThe")}{" "}
                <a href="https://sede.agenciatributaria.gob.es/static_files/common/html/selector_acceso/SelectorAccesos.html?ref=%2Fwlpl%2FSCEJ-MANT%2FCONSUL%2Findex.zul%3FMODELO%3D100%26EJERCICIO%3D-1&aut=CPRE">
                  {_t("taxAgency")}
                </a>
                .
              </li>
              <li>
                {_t("identifyYourselfUsingClaveDigitalCertificateOrDNIe")}
              </li>
              <li>
                {_t(
                  "enterYourDNIOrNIEInTaxIDChooseForm130EnterTheLastFiscalYearIfItIsNotYetJuneChooseTheOneFromThePreviousYearAndPressSearch"
                )}
              </li>
              <li>{_t("onceYouSeeTheFileClickOnView")}</li>
              <li>{_t("downloadTheDocumentWithTheArrowIcon")}</li>
            </ol>
          </>
        );
        break;
      case constants.quarterly_vat:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadLastVATQuarterlyReturnModelo303")}
            </span>
            <ol>
              <li>
                {_t("accessThe")}{" "}
                <a
                  href="https://sede.agenciatributaria.gob.es/static_files/common/html/selector_acceso/SelectorAccesos.html?ref=%2Fwlpl%2FSCEJ-MANT%2FCONSUL%2Findex.zul%3FMODELO%3D100%26EJERCICIO%3D-1&aut=CPRE"
                  target="_blank"
                >
                  {_t("taxAgency")}
                </a>
                .
              </li>
              <li>
                {_t("identifyYourselfUsingClaveDigitalCertificateOrDNIe")}
              </li>
              <li>
                {_t(
                  "enterYourDNIOrNIEInTaxIDChooseForm303EnterTheLastFiscalYearIfItIsNotYetJuneChooseTheOneFromThePreviousYearAndPressSearch"
                )}
              </li>
              <li>{_t("onceYouSeeTheFileClickOnView")}</li>
              <li>{_t("downloadTheDocumentWithTheArrowIcon")}</li>
            </ol>
          </>
        );
        break;
      case constants.comprehensive_certificate_of_benefits:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheComprehensiveBenefitsCertificate")}
            </span>
            <ol>
              <li>
                {_t("accessThe")}{" "}
                <a
                  href="https://prestaciones.seg-social.es/servicio/certificaciones-prestaciones-individual.html"
                  target="_blank"
                >
                  {_t("individualBenefitCertificate")}
                </a>
                .
              </li>
              <li>{_t("startTheApplication")}</li>
              <li>
                {_t("identifyYourselfUsingClaveDigitalCertificateOrDNIe")}
              </li>
              <li>{_t("clickOnIntegratedCertificateOfPublicBenefits")}</li>
              <li>
                {_t(
                  "theCertificateDownloadsAutomaticallyIfNotItUnblockPopupsFromSettingsAndPermissionsOfYourBrowser"
                )}
              </li>
            </ol>
          </>
        );
        break;
      case constants.corporate_tax_return:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheLastCorporateTaxReturnModelo200Or202")}
            </span>
            <ol>
              <li>
                {_t("clickOn")}{" "}
                <a
                  href="https://sede.agenciatributaria.gob.es/static_files/common/html/selector_acceso/SelectorAccesos.html?rep=S&ref=%2Fwlpl%2FIIIC-DFIS%2FVisuSocDF23Net&aut=CE"
                  target="_blank"
                >
                  {_t("taxAgency")}
                </a>
                .
              </li>
              <li>
                {_t("identifyYourselfWithTheCompanyRepresentationCertificate")}
              </li>
              <li>
                {_t(
                  "enterYourDNIOrNIEInTaxIDChooseForm200EnterTheLastFiscalYearIfItIsNotYetJuneChooseTheOneFromThePreviousYearAndPressSearch"
                )}
              </li>
              <li>{_t("onceYouSeeTheFileClickOnView")}</li>
              <li>{_t("downloadTheDocumentWithTheArrowIcon")}</li>
            </ol>
          </>
        );
        break;
      case constants.corporate_balance_sheet:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheLastCompanyBalanceSheet")}
            </span>
            <ol>
              <li>{_t("askYourManagerOrAccountant")}</li>
              <li>
                {_t(
                  "theAttachedDocumentsWillBeVerifiedThroughOurExternalDatabases"
                )}
              </li>
            </ol>
          </>
        );
        break;
      case constants.corporate_PL:
        return (
          <>
            <span className="tooltip-heading">
              {_t("howToDownloadTheLastProfitLossStatement")}
            </span>
            <ol>
              <li>{_t("askYourManagerOrAccountant")}</li>
              <li>
                {_t(
                  "theAttachedDocumentsWillBeVerifiedThroughOurExternalDatabases"
                )}
              </li>
            </ol>
          </>
        );
      case constants.certificate_of_Professional_Life:
        return (
          <>
            <span className="tooltip-heading">
              {_t(
                "ifYouDoNotBelongToTheSocialSecuritySystemYouMustProvideThisDocument"
              )}
            </span>
          </>
        );
    }
  };

  return (
    <>
      <div
        className={`col-md-${column_width} ${
          isBlurDocuments ? "blur-doc" : ""
        }`}
      >
        <div className="doc_upload_div_frame tenant-revisit-pdf-box position-relative upload-file-css">
          <div className="upload_doc_tooltip">
            <ul className="infodorpdown summarydropdum ">
              <li>
                <button className="iconinfo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M10.8 6H13.2V8.4H10.8V6ZM10.8 10.8H13.2V18H10.8V10.8ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6Z"
                      fill="#253837"
                    />
                  </svg>
                </button>{" "}
              </li>
              <ul className="tooltip">{fetchDocToolTip()}</ul>
            </ul>
          </div>
          <img
            className="upload-doc-plac-img"
            src="/images/uploadDocPlaceholder.svg"
            alt=""
          />
          <h4 data-val={dataVal}>{title}</h4>
          <p className="info-text-p">{_t("uploadPdfPngJpgOrJpeg")}</p>
          {!hideUpload && (
            <label>
              <input
                accept="application/pdf, image/jpeg, image/png, image/jpg"
                multiple={false}
                type="file"
                onChange={handleUploadFile}
                data-val={dataVal}
                className="d-none"
              />
              <span className="btn btngreen upload-btn">
                {_t("upload")} <img src="/images/uploadIcon.svg" alt="" />
              </span>
            </label>
          )}
          {!llCreated && (
            <a
              onClick={() => setMissingDocPopup(true)}
              className="text-decoration-underline text-size-sett"
            >
              {_t(
                "IDont'tHaveThisDocument",
                "Text inside upload document section"
              )}
            </a>
          )}
        </div>
      </div>
      <Modal
        show={missingDocPopup}
        onHide={() => setMissingDocPopup(false)}
        centered
        className="newmodalui asguarantor"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "reasonForNotHavingDocument",
              "Heading of missing document reason popup"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <textarea
              className="modal-textarea-div"
              type="text"
              placeholder={_t(
                "typeReason",
                "Placeholder of missing document reason popup"
              )}
              value={reasonMessage}
              onChange={(e) => setReasonMessage(e.target.value)}
            >
              {" "}
            </textarea>
            <button
              className="w-100 btn btngreen mt-2"
              disabled={reasonSubmitLoading || reasonMessage.trim() === ""}
              onClick={handleReason}
            >
              {_t("submit")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewDocumentDiv;
